import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export const AdapterOutcomeRequest = z.object({}).openapi('AdapterOutcomeRequest');

export type AdapterOutcomeRequest = z.infer<typeof AdapterOutcomeRequest>;
